import TableWrap from "../Common/Table/Table";
import { message, Button } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { userReportLinkAdv, userReports } from "../../actions/reports/reports";
import { objectToFormData } from "../../utils";
import React from "react";

message.config({
  maxCount: 3,
});

const LinkAdvsToReport = (props) => {
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = React.useState([]);
  const [reportsData, setReportsData] = React.useState([]);
  const reportsResponse = useSelector(state => state.reports.userReports || {});

  React.useEffect(() => {
    dispatch(userReports({ status: 'unsubmitted' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { response: { reports = [] } = {}, status = false } = {} } = reportsResponse;
    if (status) {
      setReportsData(reports);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsResponse]);

  const columns = [
    {
      title: "Report ID",
      dataIndex: "report_number",
      key: "report_number",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      // render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
    },
    {
      title: "Date and Time",
      dataIndex: "created_at",
      key: "created_at",
    }
  ];

  const rowSelection = {
    selectedRowKeys: selectedData,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedData(selectedRowKeys);
    }
  };

  const handleClearList = () => {
    setSelectedData([]);
  }

  const handleAddExp = () => {
    const payload = {};
    payload.advances = [props.adv_id];
    payload.id = selectedData[0];
    dispatch(userReportLinkAdv(objectToFormData({ ...payload })));
  }

  return (
    <div className="expenses-table">
      {selectedData.length ?
        <>
          <Button type="default" ghost className="approve-add-btn mb1" onClick={() => handleClearList()}>
            Clear Selection
          </Button>
          <Button
            onClick={() => handleAddExp()}
            className="floatRight ml1 primaryButton"
          >
            Add to {selectedData.length > 1 ?selectedData.length : ""} Report
          </Button></> : null}
      <TableWrap
        rowKey="id"
        columns={columns}
        data={reportsData.slice(0, 9)}
        className="tableStyled"
        pagination={false}
        rowSelection={{
          type: 'radio',
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default LinkAdvsToReport;
